export default __webpack_public_path__ + "static/media/Paytm.65a82a2f.svg";